import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  List,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class BankCaseStates extends Component {
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    customerName: PropTypes.string,
    bankCaseStates: PropTypes.shape({
      data: PropTypes.array,
    }),
    activeStatus: PropTypes.string,
  }

  static mapStateToProps = state => ({
    bankCaseStates: state.bankCaseStates,
  })

  getStatusColor = (status) => {
    switch (status) {
      case 'pending_unreachable':
      case 'pending_docs':
      case 'pending_docs_submitted':
      case 'pending_reappealed':
        return '#ff9800';

      case 'new':
        return '#03a9f4';

      case 'approved_lo_issued':
        return '#03a9f4';

      case 'reject_wrong_info':
      case 'reject_bank':
      case 'reject_developer':
      case 'reject_cancelled':
      case 'reject_customer':
      case 'reject_unqualified':
      case 'reject_lo_signed_other_bank':
        return 'red';

      case 'success_li_issued':
        return '#4CAF50';

      default:
        return '#F8F9F9';
    }
  };

  handleOnItemClick = (e, status) => {
    if (this.props.onClose) {
      this.props.onClose(e, status);
    }
  }

  render() {
    const { bankCaseStates, activeStatus, t } = this.props;
    const { data: caseStates } = bankCaseStates;
    return (
      <Modal
        className="bankcasestatus-modal"
        closeIcon
        onClose={e => this.props.onClose(e, '')}
        open={this.props.open}
        size="small"
      >
        <Modal.Header>
          {t('{{customerName}}\'s Loan Status', { customerName: this.props.customerName, ns: TRANSLATION_FILES.screens })}
        </Modal.Header>
        <Modal.Content>
          <List divided>
            {
              caseStates.map((cs, idx) => (
                <List.Item
                  key={idx}
                  className={`bankcasestatus-item ${activeStatus === cs.state ? 'disabled-item' : ''}`}
                  disabled={activeStatus === cs.state}
                  onClick={e => this.handleOnItemClick(e, cs.state)}
                >
                  <List.Icon name={activeStatus === cs.state ? 'dot circle outline' : 'circle'} style={{ color: `${this.getStatusColor(cs.state)}` }} />
                  <List.Description>{t(cs.shortName, { ns: TRANSLATION_FILES.constants })}</List.Description>
                </List.Item>
              ))
            }
          </List>
        </Modal.Content>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(connect(BankCaseStates.mapStateToProps)(BankCaseStates));



// WEBPACK FOOTER //
// ./src/containers/modals/BankCaseStates.jsx